import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.sort.js";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { CursorState } from './cursorCommon.js';
import { OneCursor } from './oneCursor.js';
import { Selection } from '../core/selection.js';
export var CursorCollection = /*#__PURE__*/function () {
  function CursorCollection(context) {
    _classCallCheck(this, CursorCollection);

    this.context = context;
    this.primaryCursor = new OneCursor(context);
    this.secondaryCursors = [];
    this.lastAddedCursorIndex = 0;
  }

  _createClass(CursorCollection, [{
    key: "dispose",
    value: function dispose() {
      this.primaryCursor.dispose(this.context);
      this.killSecondaryCursors();
    }
  }, {
    key: "startTrackingSelections",
    value: function startTrackingSelections() {
      this.primaryCursor.startTrackingSelection(this.context);

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        this.secondaryCursors[i].startTrackingSelection(this.context);
      }
    }
  }, {
    key: "stopTrackingSelections",
    value: function stopTrackingSelections() {
      this.primaryCursor.stopTrackingSelection(this.context);

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        this.secondaryCursors[i].stopTrackingSelection(this.context);
      }
    }
  }, {
    key: "updateContext",
    value: function updateContext(context) {
      this.context = context;
    }
  }, {
    key: "ensureValidState",
    value: function ensureValidState() {
      this.primaryCursor.ensureValidState(this.context);

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        this.secondaryCursors[i].ensureValidState(this.context);
      }
    }
  }, {
    key: "readSelectionFromMarkers",
    value: function readSelectionFromMarkers() {
      var result = [];
      result[0] = this.primaryCursor.readSelectionFromMarkers(this.context);

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        result[i + 1] = this.secondaryCursors[i].readSelectionFromMarkers(this.context);
      }

      return result;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var result = [];
      result[0] = this.primaryCursor.asCursorState();

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        result[i + 1] = this.secondaryCursors[i].asCursorState();
      }

      return result;
    }
  }, {
    key: "getViewPositions",
    value: function getViewPositions() {
      var result = [];
      result[0] = this.primaryCursor.viewState.position;

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        result[i + 1] = this.secondaryCursors[i].viewState.position;
      }

      return result;
    }
  }, {
    key: "getTopMostViewPosition",
    value: function getTopMostViewPosition() {
      var result = this.primaryCursor.viewState.position;

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        var viewPosition = this.secondaryCursors[i].viewState.position;

        if (viewPosition.isBefore(result)) {
          result = viewPosition;
        }
      }

      return result;
    }
  }, {
    key: "getBottomMostViewPosition",
    value: function getBottomMostViewPosition() {
      var result = this.primaryCursor.viewState.position;

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        var viewPosition = this.secondaryCursors[i].viewState.position;

        if (result.isBeforeOrEqual(viewPosition)) {
          result = viewPosition;
        }
      }

      return result;
    }
  }, {
    key: "getSelections",
    value: function getSelections() {
      var result = [];
      result[0] = this.primaryCursor.modelState.selection;

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        result[i + 1] = this.secondaryCursors[i].modelState.selection;
      }

      return result;
    }
  }, {
    key: "getViewSelections",
    value: function getViewSelections() {
      var result = [];
      result[0] = this.primaryCursor.viewState.selection;

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        result[i + 1] = this.secondaryCursors[i].viewState.selection;
      }

      return result;
    }
  }, {
    key: "setSelections",
    value: function setSelections(selections) {
      this.setStates(CursorState.fromModelSelections(selections));
    }
  }, {
    key: "getPrimaryCursor",
    value: function getPrimaryCursor() {
      return this.primaryCursor.asCursorState();
    }
  }, {
    key: "setStates",
    value: function setStates(states) {
      if (states === null) {
        return;
      }

      this.primaryCursor.setState(this.context, states[0].modelState, states[0].viewState);

      this._setSecondaryStates(states.slice(1));
    }
    /**
     * Creates or disposes secondary cursors as necessary to match the number of `secondarySelections`.
     */

  }, {
    key: "_setSecondaryStates",
    value: function _setSecondaryStates(secondaryStates) {
      var secondaryCursorsLength = this.secondaryCursors.length;
      var secondaryStatesLength = secondaryStates.length;

      if (secondaryCursorsLength < secondaryStatesLength) {
        var createCnt = secondaryStatesLength - secondaryCursorsLength;

        for (var i = 0; i < createCnt; i++) {
          this._addSecondaryCursor();
        }
      } else if (secondaryCursorsLength > secondaryStatesLength) {
        var removeCnt = secondaryCursorsLength - secondaryStatesLength;

        for (var _i = 0; _i < removeCnt; _i++) {
          this._removeSecondaryCursor(this.secondaryCursors.length - 1);
        }
      }

      for (var _i2 = 0; _i2 < secondaryStatesLength; _i2++) {
        this.secondaryCursors[_i2].setState(this.context, secondaryStates[_i2].modelState, secondaryStates[_i2].viewState);
      }
    }
  }, {
    key: "killSecondaryCursors",
    value: function killSecondaryCursors() {
      this._setSecondaryStates([]);
    }
  }, {
    key: "_addSecondaryCursor",
    value: function _addSecondaryCursor() {
      this.secondaryCursors.push(new OneCursor(this.context));
      this.lastAddedCursorIndex = this.secondaryCursors.length;
    }
  }, {
    key: "getLastAddedCursorIndex",
    value: function getLastAddedCursorIndex() {
      if (this.secondaryCursors.length === 0 || this.lastAddedCursorIndex === 0) {
        return 0;
      }

      return this.lastAddedCursorIndex;
    }
  }, {
    key: "_removeSecondaryCursor",
    value: function _removeSecondaryCursor(removeIndex) {
      if (this.lastAddedCursorIndex >= removeIndex + 1) {
        this.lastAddedCursorIndex--;
      }

      this.secondaryCursors[removeIndex].dispose(this.context);
      this.secondaryCursors.splice(removeIndex, 1);
    }
  }, {
    key: "_getAll",
    value: function _getAll() {
      var result = [];
      result[0] = this.primaryCursor;

      for (var i = 0, len = this.secondaryCursors.length; i < len; i++) {
        result[i + 1] = this.secondaryCursors[i];
      }

      return result;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      if (this.secondaryCursors.length === 0) {
        return;
      }

      var cursors = this._getAll();

      var sortedCursors = [];

      for (var i = 0, len = cursors.length; i < len; i++) {
        sortedCursors.push({
          index: i,
          selection: cursors[i].modelState.selection
        });
      }

      sortedCursors.sort(function (a, b) {
        if (a.selection.startLineNumber === b.selection.startLineNumber) {
          return a.selection.startColumn - b.selection.startColumn;
        }

        return a.selection.startLineNumber - b.selection.startLineNumber;
      });

      for (var sortedCursorIndex = 0; sortedCursorIndex < sortedCursors.length - 1; sortedCursorIndex++) {
        var current = sortedCursors[sortedCursorIndex];
        var next = sortedCursors[sortedCursorIndex + 1];
        var currentSelection = current.selection;
        var nextSelection = next.selection;

        if (!this.context.cursorConfig.multiCursorMergeOverlapping) {
          continue;
        }

        var shouldMergeCursors = void 0;

        if (nextSelection.isEmpty() || currentSelection.isEmpty()) {
          // Merge touching cursors if one of them is collapsed
          shouldMergeCursors = nextSelection.getStartPosition().isBeforeOrEqual(currentSelection.getEndPosition());
        } else {
          // Merge only overlapping cursors (i.e. allow touching ranges)
          shouldMergeCursors = nextSelection.getStartPosition().isBefore(currentSelection.getEndPosition());
        }

        if (shouldMergeCursors) {
          var winnerSortedCursorIndex = current.index < next.index ? sortedCursorIndex : sortedCursorIndex + 1;
          var looserSortedCursorIndex = current.index < next.index ? sortedCursorIndex + 1 : sortedCursorIndex;
          var looserIndex = sortedCursors[looserSortedCursorIndex].index;
          var winnerIndex = sortedCursors[winnerSortedCursorIndex].index;
          var looserSelection = sortedCursors[looserSortedCursorIndex].selection;
          var winnerSelection = sortedCursors[winnerSortedCursorIndex].selection;

          if (!looserSelection.equalsSelection(winnerSelection)) {
            var resultingRange = looserSelection.plusRange(winnerSelection);
            var looserSelectionIsLTR = looserSelection.selectionStartLineNumber === looserSelection.startLineNumber && looserSelection.selectionStartColumn === looserSelection.startColumn;
            var winnerSelectionIsLTR = winnerSelection.selectionStartLineNumber === winnerSelection.startLineNumber && winnerSelection.selectionStartColumn === winnerSelection.startColumn; // Give more importance to the last added cursor (think Ctrl-dragging + hitting another cursor)

            var resultingSelectionIsLTR = void 0;

            if (looserIndex === this.lastAddedCursorIndex) {
              resultingSelectionIsLTR = looserSelectionIsLTR;
              this.lastAddedCursorIndex = winnerIndex;
            } else {
              // Winner takes it all
              resultingSelectionIsLTR = winnerSelectionIsLTR;
            }

            var resultingSelection = void 0;

            if (resultingSelectionIsLTR) {
              resultingSelection = new Selection(resultingRange.startLineNumber, resultingRange.startColumn, resultingRange.endLineNumber, resultingRange.endColumn);
            } else {
              resultingSelection = new Selection(resultingRange.endLineNumber, resultingRange.endColumn, resultingRange.startLineNumber, resultingRange.startColumn);
            }

            sortedCursors[winnerSortedCursorIndex].selection = resultingSelection;
            var resultingState = CursorState.fromModelSelection(resultingSelection);
            cursors[winnerIndex].setState(this.context, resultingState.modelState, resultingState.viewState);
          }

          var _iterator = _createForOfIteratorHelper(sortedCursors),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var sortedCursor = _step.value;

              if (sortedCursor.index > looserIndex) {
                sortedCursor.index--;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          cursors.splice(looserIndex, 1);
          sortedCursors.splice(looserSortedCursorIndex, 1);

          this._removeSecondaryCursor(looserIndex - 1);

          sortedCursorIndex--;
        }
      }
    }
  }]);

  return CursorCollection;
}();